export const addressFragment = `
fragment Address on Address {
    additionalInformation1
    additionalInformation2
    addOn
    city
    country
    countryCode
    stateOrDistrict
    streetName
    streetNumber
    town
    zipCode
  }
`;
